import { initializeApp } from "firebase/app";
import { Secrets } from "./secrets";
import { browserSessionPersistence, getAuth, setPersistence } from "firebase/auth";

export const firebaseApp = initializeApp(Secrets.FirebaseConfig);
export const auth = getAuth(firebaseApp);

setPersistence(auth, browserSessionPersistence)
  .then(() => { })
  .catch((_) => { });